import "katex/dist/katex.min.css";

import Latex from "react-latex-next";
import type { FC } from "react";

import { AbilityScore, AnswerExercise } from "components";

import { useAppSelector } from "store/hooks";
import { getAbilityScore } from "store/slices/exercise";
import type { IAssignmentResult, IOption } from "store/slices/exercise";

import { generalOptionText } from "utils/formatTextForAnalysis";
import { getTextForSelfEvaluationOption } from "utils/getTextForSelfEvaluationOption";
import { isSelfEvaluationForEveryAssignment } from "utils/valueTranslators";
import { getAbilityScoreOptions } from "utils/changeAbilityScore";

import type { UserAssignmentForExerciseFragment } from "api/generated";
import { AssignmentPrompt } from "components/AssignmentPrompt";

/* gMrM0Kqx0aR88Z5kYMlK */

interface Props {
  assignmentResult: IAssignmentResult<IOption | string>;
  assignmentDetail: UserAssignmentForExerciseFragment;
  toggleModals: (showQuestionAnalysisIndex: number | null) => void;
}

const ViceslovneOdpovedi: FC<Props> = ({ assignmentDetail, assignmentResult, toggleModals }) => {
  const { assignment } = assignmentDetail;
  if (assignment === undefined || assignment === null) return null;

  const isSelfEvaluation = assignment.scoring?.scoringMethod.scoringMethod === "sebeopravení";
  const abilityScore = useAppSelector(getAbilityScore(assignmentDetail.id));

  const getAbilityScoreOnIndex = (index: number) => {
    if (abilityScore === undefined || typeof abilityScore === "number") return 0;

    return abilityScore[index];
  };

  return (
    <div>
      <AssignmentPrompt assignment={assignment?.assignment} />

      {assignment.assignment?.questions.map((question, qIndex) => (
        <div key={qIndex} className="mt-20px question">
          <Latex>{question.heading ?? ""}</Latex>

          <AnswerExercise
            subject={assignmentDetail.subject?.appName}
            key={`answer-${qIndex}`}
            index={qIndex}
            assignment={assignment}
            type={assignmentResult.answersVariants?.[qIndex]}
            toggleModals={toggleModals}
            userAssignmentId={assignmentDetail.id}
            addIcon={!isSelfEvaluation}
            tipDisabled={true}
          >
            {isSelfEvaluation
              ? getTextForSelfEvaluationOption(assignmentResult.selfEvalAnswers[qIndex]?.status ?? "danger")
              : generalOptionText(assignmentResult.answers?.[qIndex] ?? "")}
          </AnswerExercise>

          {isSelfEvaluationForEveryAssignment(assignment) && question.showAbilityScore === true ? (
            <>
              <hr className={"my-25px"} />
              <div className="mw-sm">
                <AbilityScore
                  isSelfEvaluated={isSelfEvaluation}
                  options={getAbilityScoreOptions(isSelfEvaluation, assignmentResult.answersVariants?.[qIndex])}
                  selectedValue={getAbilityScoreOnIndex(qIndex)}
                  onValueSelect={() => {}}
                  index={qIndex}
                  key={qIndex}
                />
              </div>
            </>
          ) : null}
        </div>
      ))}
    </div>
  );
};

export default ViceslovneOdpovedi;
